<template>
  <div class="memberAll">
    <div
      class="global-content-box global-content-flex"
      v-if="!isShowReords && !isShowDetails"
    >
      <y-menu-title />
      <!-- 数据概览 -->
       <div class="dataSummary">
         <y-Title label="数据概览"></y-Title>
         <div @click="isShowDataSummary = !isShowDataSummary" class="dataSummary_title">
          {{ isShowDataSummary ? '收起' : '展开' }}
          <i v-if="!isShowDataSummary" class="el-icon-arrow-down"></i>
          <i v-else class="el-icon-arrow-up"></i>
         </div>
       </div>
       <dataSummary v-if="isShowDataSummary" class="dataSummary_content"></dataSummary>
      <!-- 顶部搜索区域 -->
      <div>
        <y-form
          ref="searchForm"
          :form-info="formInfoNew"
          @search="getSearch"
          @selfReset="getClean"
        >
          <template #orderId>
            <el-input
              size="small"
              placeholder="请输入"
              style="width: 290px"
              v-model="orderSearch.orderId"
            ></el-input>
          </template>
          <template #shop>
            <el-select
              v-model="orderSearch.shopId"
              placeholder="请选择"
              style="width: 290px"
            >
              <el-option
                v-for="item in shopList"
                :key="item.channelSellerManageId"
                :label="item.shopTitle"
                :value="item.channelSellerManageId"
              >
              </el-option>
            </el-select>
          </template>
          <template #orderBtn>
            <div class="btn-wrap">
              <y-button type="blueLine" @click="getUserInfoByOrder"
                >根据订单获取用户信息</y-button
              >
              <div class="btn-wrap__btn">
                <y-tip type="gley-empty">
                  <span
                    >提示：根据订单查询可获取用户信息</span
                  >
                  <span v-if="orderSearch.mobile">：{{ orderSearch.mobile }}</span>
                </y-tip>
              </div>
            </div>
          </template>
          <template #platform>
            <el-select
              class="selectType"
              v-model="formDataList.platform"
              placeholder="请选择"
              style="width: 141px"
              size="small"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in platformList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              size="small"
              placeholder="请输入"
              style="width: 141px; margin-left: 8px"
              v-model="formDataList.account"
            ></el-input>
          </template>
          <template #grade>
            <el-select
              class="selectType"
              v-model="formDataList.grade"
              placeholder="请选择"
              style="width: 290px"
              size="small"
            >
              <el-option
                v-for="item in memberLevelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template #channelSellerManageIdList>
            <el-select
              v-model="channelSellerManageIdList"
              placeholder="默认所有店铺"
              collapse-tags
              multiple
              style="width: 290px"
            >
              <el-option
                v-for="item in shopList"
                :key="item.channelSellerManageId"
                :label="item.shopTitle"
                :value="item.channelSellerManageId"
              >
              </el-option>
            </el-select>
          </template>
          <template #vipType>
            <el-select
              class="selectType"
              v-model="formDataList.vipType"
              placeholder="请选择"
              style="width: 290px"
              size="small"
            >
              <el-option
                v-for="item in vipTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template #activeStatus>
            <el-select
              class="selectType"
              v-model="formDataList.activeStatus"
              placeholder="请选择"
              style="width: 290px"
              size="small"
            >
              <el-option
                v-for="item in activeStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </y-form>
      </div>
      <!-- 操作按钮栏 -->
      <div class="buttonGroup">
        <y-button @click="getImportDialog(1)" v-permission="'hyt:member:import'"
          >导入会员</y-button
        >
        <y-button @click="getImportDialog(2)" v-permission="'hyt:point:import'"
          >导入积分</y-button
        >
        <y-button
          @click="isShowReords = true"
          v-permission="'hyt:import:record'"
          >导入记录</y-button
        >
        <y-button
          @click="getQueryPointsDialog"
          >查询即将过期积分</y-button
        >
      </div>
      <!-- 活动列表 -->
      <div :class="['global-felx-1', {'tableHg': isShowDataSummary}]">
        <y-table
          v-if="isShowTable"
          :tableData="tableData"
          :tableInfo="tableInfoNew"
          tooltip-effect="dark"
          :loading="talbeLoading"
          :pageInfo="{
            pageNum: pageInfo.pageNum,
            pageSize: pageInfo.pageSize,
            total: totalList,
          }"
          @handlePage="handlePage"
        >
          <template #mobile="scope">
            <div class="basicTitle" style="display: flex">
              <!-- scope.row.showPhoneNumber &&  -->
              <span v-if="scope.row.mobile">
                {{ scope.row.mobile | filterPhone(scope.row.mobile) }}
                <!-- v-if="scope.row.mobile" -->
                <img
                  v-if="false"
                  slot="reference"
                  src="@/assets/images/隐藏.svg"
                  alt=""
                  @click="togglePhoneNumberVisibility(scope.rowIndex)"
                  style="
                    margin-left: 12px;
                    cursor: pointer;
                    position: relative;
                    top: 3px;
                  "
              /></span>
              <!-- v-else -->
              <span v-if="false"
                >{{ scope.row.mobile ? scope.row.mobile : "-"
                }}<img
                  v-if="scope.row.mobile"
                  slot="reference"
                  src="@/assets/images/显示.svg"
                  alt=""
                  @click="togglePhoneNumberVisibility(scope.rowIndex)"
                  style="
                    margin-left: 17px;
                    cursor: pointer;
                    position: relative;
                    top: 3px;
                  "
              /></span>
            </div>
          </template>
          <template #grade="scope">
            <!-- <el-popover trigger="hover" placement="top">
          <p>(点击编辑)</p>
          <p>{{ scope.row.memberLevel }}</p>
          <p>有效期：永久有效</p>
          <div slot="reference" class="hoverTitle" >
            {{ scope.row.memberLevel }}
          </div>
        </el-popover> -->
            <span v-if="scope.row.isVip == 0">
              非会员 
            </span>
            <el-tooltip placement="top-start" v-else>
              <div slot="content">
                <p @click="levelDialog(scope.row)" style="cursor: pointer">
                  (点击编辑)
                </p>
                <p>{{ gradeLabel(scope.row.grade) }}</p>
                <p>
                  有效期：{{
                    scope.row.gradeValidTime ? scope.row.gradeValidTime : "-"
                  }}
                </p>
              </div>
              <div @click="levelDialog(scope.row)">
                <div>
                  <y-button type="blueText"
                    >{{ gradeLabel(scope.row.grade) }}</y-button
                  >
                </div>
                <div>
                  <y-button type="blueText"
                    >有效期：{{
                      scope.row.gradeValidTime ? scope.row.gradeValidTime : "-"
                    }}</y-button
                  >
                </div>
              </div>
            </el-tooltip>
          </template>

          <template #pointBalance="scope">
            <!-- <el-popover trigger="hover" placement="top">
          <p>(点击编辑)</p>
          <p>积分:{{ scope.row.integral }}</p>
          <div slot="reference" class="hoverTitle" >
            {{ scope.row.integral }}
          </div>
        </el-popover> -->
            <el-tooltip placement="top-start">
              <div slot="content">
                <p @click="integralDialog(scope.row)" style="cursor: pointer">
                  (点击编辑)
                </p>
                <p>
                  积分：{{
                    scope.row.pointBalance ? scope.row.pointBalance : "-"
                  }}
                </p>
              </div>
              <y-button type="blueText" @click="integralDialog(scope.row)">{{
                scope.row.pointBalance ? scope.row.pointBalance : "-"
              }}</y-button>
            </el-tooltip>
          </template>

          <template #grow="scope">
            <!-- <el-popover trigger="hover" placement="top">
            <p>(点击编辑)</p>
            <p>成长值:{{ scope.row.grow }}</p>
            <div slot="reference" class="hoverTitle" >
              {{ scope.row.grow }}
            </div>
          </el-popover> -->

            <el-tooltip placement="top-start">
              <div slot="content">
                <p style="cursor: pointer" @click="growDialog(scope.row)">
                  (点击编辑)
                </p>
                <p>成长值：{{ scope.row.grow ? scope.row.grow : "-" }}</p>
              </div>
              <y-button type="blueText" @click="growDialog(scope.row)">{{
                scope.row.grow ? scope.row.grow : "-"
              }}</y-button>
            </el-tooltip>
          </template>
          <template #activeStatus="scope">
            <span> {{ scope.row.activeStatus == 1 ? "未激活" : scope.row.activeStatus == 2 ? "已激活" : "-" }} </span>
          </template>
          <template #edit="scope">
            <y-button type="blueText" @click="handleEdit(scope.row)"
              >会员详情</y-button
            >
             <y-button type="blueText" @click="openOrderDetails(scope.row)"
              >订单详情</y-button
            >
          </template>
        </y-table>
      </div>
    </div>
    <!-- 订单详情 -->
    <order-Details ref="orderDetailsRef" :memberId="memberId"></order-Details>
    <!-- 导入记录 -->
    <import-Records
      v-if="isShowReords"
      @close="isShowReords = false"
    ></import-Records>
    <!-- 会员详情 -->
    <member-Details
      v-if="isShowDetails"
      @close="closeDetails"
      :memberId="memberId"
      :memberLevelList="memberLevelList"
    ></member-Details>
    <!-- 编辑弹窗 -->
    <modify-Dialog
      v-if="isShowModify"
      @close="isShowModify = false"
      :isShowDialog="isShowModify"
      :isShowType="editType"
      :editItem="editItem"
      :memberLevelList="memberLevelList"
      @finishEdit="finishEdit"
    ></modify-Dialog>
    <!-- 导入弹窗 -->
    <import-Dialog
      v-if="isShowImport"
      @close="isShowImport = false"
      :isShowDialog="isShowImport"
      :isShowType="importType"
    ></import-Dialog>
    <!-- 选择店铺弹窗 -->
    <chooseShop
      v-if="chooseShopShow"
      :visible="chooseShopShow"
      :selected.sync="channelSellerManageIdList"
      @close="chooseShopShow = false"
    ></chooseShop>
    <!-- 查询即将过期积分弹窗 -->
    <queryPointsDialog
      v-if="isShowQueryPoints"
      @close="isShowQueryPoints = false"
      :isShowDialog="isShowQueryPoints"
    ></queryPointsDialog>
  </div>
</template>

<script>
import importRecords from "./compontents/importRecords.vue";
import memberDetails from "./compontents/memberDetails.vue";
import modifyDialog from "./compontents/modifyDialog.vue";
import importDialog from "./compontents/importDialog.vue";
import chooseShop from "@/components/chooseShop.vue";
import dataSummary from "./compontents/dataSummary.vue";
import orderDetails from "./compontents/orderDetails.vue";
import queryPointsDialog from "./compontents/queryPointsDialog.vue";
import {
  getCDPMemberList,
  getMemberInfoDyOrderId,
} from "@/api/memberMessageSystem";
import { isScoresBindList,getDetailById } from "@/api/integralCenter/newMemberSystem";
import { getGradeList } from "@/api/manage/scoreList";
export default {
  name: "memberAll",
  components: {
    importRecords,
    memberDetails,
    modifyDialog,
    importDialog,
    chooseShop,
    dataSummary,
    orderDetails,
    queryPointsDialog,
  },
  data() {
    return {
      isShowTable: true,
      isShowDataSummary: false,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      formDataList: {
        memberId: null,
        mobile: null,
        grade: "",
        growStart: "",
        growEnd: "",
        channelSellerManageId: "",
        platform: "", //不限为空  1:淘宝 2:京东 3:有赞 4:微信 5:抖音 6:快手
        account: "",
        pointStart: "",
        pointEnd: "",
        firstJoinTimeStart: "",
        firstJoinTimeEnd: "",
        lastJoinTimeStart: "",
        lastJoinTimeEnd: "",
        scoresCardId: "",
        successMoneyStart: "",
        successMoneyEnd: "",
        vipType: 1,
        activeStatus: 0,
        activeTimeStart: "",
        activeTimeEnd: "",
      },
      //会员等级类型
      memberLevelList: [],
      vipTypeList: [
        {
          label: "全部",
          value: 1,
        },
        {
          label: "会员",
          value: 2,
        },
        {
          label: "非会员",
          value: 3,
        },
      ],
      activeStatusList: [
        {
          label: "不限",
          value: 0,
        },
        {
          label: "未激活",
          value: 1,
        },
        {
          label: "已激活",
          value: 2,
        },
      ],
      talbeLoading: false,
      tableData: [],
      totalList: 0,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formDataList.endTime) {
            return (
              time.getTime() > new Date(this.formDataList.endTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formDataList.startTime) {
            return (
              time.getTime() < new Date(this.formDataList.startTime).getTime()
            );
          } else {
          }
        },
      },
      isShowReords: false, //显示导入记录
      isShowDetails: false, //显示会员详情
      isShowModify: false, //显示编辑弹窗
      editType: 1, //1积分操作 2等级修改 3成长值操作
      editItem: {}, //传入弹窗值
      isShowImport: false, //导入弹窗
      isShowQueryPoints: false, //查询即将过期积分弹窗
      importType: 1, //1会员导入
      chooseShopShow: false, //选择店铺弹窗
      channelSellerManageIdList: [], // 店铺id列表
      shopList: [],
      orderSearch: {
        orderId: "",
        shopId: "",
        mobile: "",
      },
      formInfo: [
        {
          label: "订单号：",
          prop: "orderId",
          slot: "orderId",
        },
        {
          label: "店铺：",
          prop: "shop",
          slot: "shop",
        },
        {
          label: " ",
          prop: "orderBtn",
          slot: "orderBtn",
        },
        {
          label: "",
          slot: "empty",
        },
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员账号：",
          prop: "platform",
          slot: "platform",
        },
        {
          label: "手机号：",
          prop: "mobile",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "grade",
          slot: "grade",
        },
        {
          label: "可用积分：",
          startKey: "pointStart",
          endKey: "pointEnd",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "成长值：",
          startKey: "growStart",
          endKey: "growEnd",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "累计交易金额：",
          startKey: "successMoneyStart",
          endKey: "successMoneyEnd",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "首次入会时间：",
          prop: "time",
          type: "DateRange",
          dateType: "datetime",
          startKey: "firstJoinTimeStart",
          endKey: "firstJoinTimeEnd",
        },
        {
          label: "最近一次入会时间：",
          prop: "lastJoinTime",
          type: "DateRange",
          dateType: "datetime",
          startKey: "lastJoinTimeStart",
          endKey: "lastJoinTimeEnd",
        },
        {
          label: "首次入会店铺：",
          prop: "channelSellerManageIdList",
          slot: "channelSellerManageIdList",
        },
        {
          label: "是否会员：",
          prop: "vipType",
          slot: "vipType",
        },
        {
          label: "淘宝平台会员激活状态：",
          prop: "activeStatus",
          slot: "activeStatus",
        },
        {
          label: "淘宝平台会员激活时间：",
          prop: "activeTime",
          type: "DateRange",
          dateType: "datetime",
          startKey: "activeTimeStart",
          endKey: "activeTimeEnd",
        },
      ],
      tableInfo: [
        {
          label: "全渠道会员ID",
          prop: "memberId",
          width: "150px",
        },
        {
          label: "手机号",
          prop: "mobile",
          slot: "mobile",
        },
        {
          label: "等级",
          prop: "grade",
          slot: "grade",
          width: "250px",
        },
        {
          label: "可用积分",
          prop: "pointBalance",
          slot: "pointBalance",
          align: "right",
        },
        {
          label: "成长值",
          prop: "grow",
          slot: "grow",
          align: "right",
        },
        {
          label: "累计交易金额",
          prop: "successMoney",
          align: "right",
        },
        {
          label: "首次入会时间",
          prop: "firstJoinTime",
        },
        {
          label: "最近一次入会时间",
          prop: "lastJoinTime",
        },
        {
          label: "首次入会店铺",
          prop: "firstJoinShopName",
        },
        {
          label: "淘宝平台会员激活状态",
          prop: "activeStatus",
          slot: "activeStatus",
          width: "160px"
        },
        {
          label: "淘宝平台会员激活时间",
          prop: "activeTime",
          width: "170px"
        },
        {
          label: "操作",
          prop: "edit",
          slot: "edit",
        },
      ],
      memberId: "",
    };
  },
  watch: { 
    isShowDataSummary () {
        this.isShowTable=false
        this.$nextTick(()=>{
          this.isShowTable=true
        })
    }
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "会员总览");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.formDataList.scoresCardId = this.MemberSystemInfo.scoresCardId;
    this.getActivityList();
    this.getShopList();
    this.gradeList();
  },
  computed: {
    platformList() {
      let list = this.$platformList;
      console.log(this.shopList);
      list = list.filter((item) => {
        return this.shopList.some((obj) => {
          return item.value == obj.platform;
        });
      });
      return list;
    },
    isShowTbPlatform() {
      if(this.platformList && this.platformList.length > 0) {
        return this.platformList.some((item) => item.value == 1);
      }else{
        return false;
      }
    },
    formInfoNew(){
      if(this.isShowTbPlatform){
        return this.formInfo
      }else{
        return this.formInfo.filter((item) => item.prop != "activeStatus" && item.prop != "activeTime");
      }
    },
    tableInfoNew(){
      if(this.isShowTbPlatform){
        return this.tableInfo
      }else{
        return this.tableInfo.filter((item) => item.prop != "activeStatus" && item.prop != "activeTime");
      }
    }
  },
  filters: {
    filterPhone: function (value) {
      if (value) {
        return value.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      }
    },
  },
  methods: {
    // gradeList() {
    //   this.selectLoading = true;
    //   getGradeList({ scoresCardId: this.MemberSystemInfo.scoresCardId }).then(
    //     (res) => {
    //       let leveNameList = [
    //         "等级一",
    //         "等级二",
    //         "等级三",
    //         "等级四",
    //         "等级五",
    //         "等级六",
    //         "等级七",
    //       ];
    //       let arr = [];
    //       this.memberLevelList = [];
    //       arr = res.data.map((item, index) => {
    //         return { label: leveNameList[index], value: index + 1 };
    //       });
    //       this.memberLevelList.push({
    //         value: "",
    //         label: "全部",
    //       });
    //       arr.forEach((item) => this.memberLevelList.push(item));

    //       this.selectLoading = false;
    //     }
    //   );
    // },
    gradeList(){
      this.selectLoading = true;
      getDetailById({
        cardId: this.$store.state.MemberSystemInfo.scoresCardId,
      }).then((res) => {
          let arr = [];
          this.memberLevelList = [];
          arr = res.data.gradeList.map((item, index) => {
            return { label: item.gradeName+"(Lv."+item.gradeCode+")", value: item.gradeCode };
          });
          this.memberLevelList.push({
            value: "",
            label: "全部",
          });
          arr.forEach((item) => this.memberLevelList.push(item));
          this.selectLoading = false;
      });
    },
    gradeLabel(grade) {
      if (grade === "" || grade === null || grade === undefined) return "-";
      const level = this.memberLevelList.find(
        (item) => String(item.value) === String(grade)
      );
      return level ? level.label : grade;
    },
    // 获取选择店铺
    getShopList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      };
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.shopList = res.data.dataList;
        }
      });
    },
    // 获取活动列表
    getActivityList() {
      this.talbeLoading = true;
      this.formDataList.channelSellerManageIdList =
        this.channelSellerManageIdList.toString();
      getCDPMemberList({ ...this.formDataList, ...this.pageInfo }).then(
        (res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.totalList = res.data.pageInfo.total;
            // this.tableData = res.data.dataList.map((item) => {
            //   return { ...item, showPhoneNumber: true };
            // });
          }
        }
      );
    },
    getSearch(obj) {
      for (const key in obj) {
        if (
          key != "platform" &&
          key != "account" &&
          key != "grade" &&
          key != "grade" &&
          key != "channelSellerManageIdList" &&
          key != "vipType" &&
          key != "activeStatus"
        ) {
          this.formDataList[key] = obj[key];
        }
      }
      this.pageInfo.pageNum = 1;
      this.getActivityList();
    },
    closeDetails() {
      this.isShowDetails = false;
      this.getActivityList();
      this.getShopList();
    },
    // 手机号码的脱敏和显示切换
    togglePhoneNumberVisibility(index) {
      this.tableData[index].showPhoneNumber =
        !this.tableData[index].showPhoneNumber;
    },
    //重置
    getClean() {
      this.formDataList = {
        memberId: null,
        mobile: null,
        grade: "",
        growStart: "",
        growEnd: "",
        channelSellerManageId: "",
        platform: "", //1 不限  1:淘宝 2:京东 3:有赞 4:微信 5:抖音 6:快手
        account: "",
        pointStart: "",
        pointEnd: "",
        firstJoinTimeStart: "",
        firstJoinTimeEnd: "",
        lastJoinTimeStart: "",
        lastJoinTimeEnd: "",
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        successMoneyStart: "",
        successMoneyEnd: "",
        vipType: 1,
        activeStatus: 0,
        activeTimeStart: "",
        activeTimeEnd: "",
      };
      (this.channelSellerManageIdList = []), this.getActivityList();
    },
    //点击积分弹窗
    integralDialog(item) {
      this.editItem = item;
      this.isShowModify = true;
      this.editType = 1;
    },
    //点击等级弹窗
    levelDialog(item) {
      this.editItem = item;
      this.isShowModify = true;
      this.editType = 2;
    },
    //点击成长值弹窗
    growDialog(item) {
      this.editItem = item;
      this.isShowModify = true;
      this.editType = 3;
    },
    //点击导入弹窗
    getImportDialog(type) {
      if (type == 1) {
        //会员导入
        this.importType = 1;
        this.isShowImport = true;
      } else {
        // 积分导入
        this.importType = 2;
        this.isShowImport = true;
      }
    },
    //查询即将过期积分弹窗
    getQueryPointsDialog(){
      this.isShowQueryPoints = true;
    },
    //打开选择店铺
    getChooseShopShow() {
      this.chooseShopShow = true;
    },
    //关闭选择店铺
    shopClose() {
      this.chooseShopShow = false;
    },
    finishEdit() {
      this.isShowModify = false;
      this.getActivityList();
    },
    //编辑
    handleEdit(item) {
      this.memberId = item.memberId;
      this.isShowDetails = true;
    },
    handlePage(page) {
      this.pageInfo.pageNum = page.pageNum;
      this.pageInfo.pageSize = page.pageSize;
      this.getActivityList();
    },
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.getActivityList();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.getActivityList();
    },
    // 清除时间
    clearTimeSendTime() {
      (this.formDataList.firstJoinTimeStart = ""),
        (this.formDataList.firstJoinTimeEnd = "");
    },
    // 验证输入框
    validSeInput(dataName, data) {
      let nowItemData = Number(data);
      if (dataName == "start" && Number(this.formDataList.successMoneyEnd)) {
        if (this.formDataList.successMoneyEnd <= nowItemData) {
          this.$message.warning("开始值要小于结束值");
          this.formDataList.successMoneyStart = "";
        } else {
          this.formDataList.successMoneyStart = nowItemData;
        }
      }
      if (dataName == "end" && Number(this.formDataList.successMoneyStart)) {
        if (this.formDataList.successMoneyStart >= nowItemData) {
          this.$message.warning("结束值要大于开始值");
          this.formDataList.successMoneyEnd = "";
        } else {
          this.formDataList.successMoneyEnd = nowItemData;
        }
      }
    },
    // 根据订单获取用户信息
    getUserInfoByOrder() {
      if (!this.orderSearch.orderId) {
        this.$message.warning("请输入订单号");
        return;
      }
      if (!this.orderSearch.shopId) {
        this.$message.warning("请选择店铺");
        return;
      }
      getMemberInfoDyOrderId({
        orderId: this.orderSearch.orderId,
        shopId: this.orderSearch.shopId,
      }).then((res) => {
        if (res.code == 200) {
          this.formDataList.account = res.data.openId;
          this.orderSearch.mobile = res.data.mobile;
        }
      });
    },
    // 打开订单详情弹窗
    openOrderDetails(item) {
      this.$refs.orderDetailsRef.openDrawer(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.memberAll {
  height: 100%;
}
.displayItem {
  display: flex;
}
.buttonGroup {
  margin: 16px 0;
}
.btn-wrap {
  display: flex;
  white-space: nowrap;
  align-items: center;
  &__btn {
    margin-left: 16px;
  }
}
.dataSummary{
  display: flex;
  cursor: pointer;
  .dataSummary_title{
    margin-left: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #007BFF;
  }
}
.dataSummary_content{
  margin-bottom: 16px;
  width: 100%;
}
.tableHg{
  height: 500px;
  min-height: 500px;
  overflow: auto;
}
</style>